export const projectStyle = {
    computer: {
        
        subSection: {
            linkHeader: {
                color: "white",
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif"
            },
            listItem: {
                color: "white",
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif"
            },
            container: {
                marginTop: "0",
                border: "solid white 2px"
            },
            header: {
                color: "white",
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                marginBottom: "5%"
            },
            link: {
                color: "white",
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                textDecorationLine: "underline"
            }
        }
    },
    tablet: {
        general: {
            page: {
                marginTop: "3%"
            },
            headerContainer: {
                margin: "0 auto",
                width: "70%"
            },
            header: {
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif"
            },
            subheader: {
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                marginBottom: "1%"
            },
            container: {
                backgroundColor: "rgb(180, 74, 70)",
                margin: "0 auto",
                width: "70%",
                padding: "1%",
                overflowY: "auto",
                height: "715px"
            }
        },
        subSection: {
            image: {
                marginTop: "2.5%"
            },
            linkHeader: {
                color: "white",
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif"
            },
            listItem: {
                color: "white",
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif"
            },
            header: {
                color: "white",
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                marginBotton: "5%"
            },
            link: {
                color: "white",
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                textDecorationLine: "underline"
            },
            container: {
                border: "solid white 2px",
                marginTop: "5%"
            }
        }
    },
    mobile: {
        general: {
            page: {
                marginTop: "3%"
            },
            headerContainer: {
                margin: "0 auto",
                width: "70%"
            },
            header: {
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif"
            },
            subheader: {
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif",
                marginBottom: "1%"
            },
            container: {
                backgroundColor: "rgb(180, 74, 70)",
                margin: "0 auto",
                width: "70%",
                padding: "1%",
                overflowY: "auto",
                height: "715px"
            }
        },
        subSection: {
            image: {
                marginBottom: "5%"
            },
            container: {
                marginTop: "0",
                border: "solid white 2px"
            },
            linkContainer: {
                marginTop: "5%"
            },
            listItem: {
                color: "white",
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif"
            },
            header: {
                color: "white",
                fontFamily: "Cambria, Cochin, Georgia, Times, 'Times New Roman', serif"
            },
            icon: {
                color: "white"
            }
        }
    }
};